import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { ReservationStore } from '../service/reservation-store';
import { Reservation } from '../models/reservation';

@Injectable()
export class ReservationResolver implements Resolve<any> {
  constructor(private reservationStore: ReservationStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<Reservation>> {
    const id = route.params[ 'id' ];
    const eventPartyId = route.params[ 'eventPartyId' ];

    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_RESERVATIONS'));
    }

    if (eventPartyId) {
      return this.reservationStore.loadReservationsByParty(id, eventPartyId);
    } else {
      return this.reservationStore.loadReservations(id);
    }

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation.resolver.ts